<template>
  <div>
    <Main
      :height="height"
      :loading="loading"
      :tableData="tableData"
      ref="tableMain"
    >
      <Header @batchDel="batchDel" ref="tableHeader" slot="header" />
    </Main>
  </div>
</template>
<script>
import Main from './main.vue'
import Header from './header.vue'
export default {
  components: { Main, Header },
  props: {
    height: { type: Number, default: 500 },
    packValue: { type: Array, default: () => [] },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      goodsSpecDetailDialogParams: {
        visible: false,
        title: '',
        disabled: false,
        code: '',
      },
    }
  },
  watch: {
    packValue: {
      handler(value) {
        if (value) this.tableData = value
      },
      immediate: true,
    },
  },
  mounted() {
    const $tableMain = this.$refs.tableMain
    this.$eventBus.$on('addGoodsPackage', (data) => {
      if ($tableMain) $tableMain.insertAt(data, true)
    })
  },
  methods: {
    batchDel() {
      const $tableMain = this.$refs.tableMain
      $tableMain.removeCheckboxRow()
    },
    async getTableData() {
      const $tableMain = this.$refs.tableMain

      const validResult = await $tableMain.validEvent()
      if (!validResult) throw new Error('包装数据检验失败！')

      return await $tableMain.getTableData()
    },
  },
}
</script>
